if (!customElements.get('bundle-buntton')) {
    customElements.define('bundle-buntton', class bundleProducts extends HTMLElement {
      constructor() {
        super();
        this.bundleId = new Date().getTime();
      }
  
      connectedCallback() {
        this.querySelector('.js-bundle-add-cart').addEventListener('click', this.onSubmitHandler2.bind(this));
        this.cart = document.querySelector('cart-drawer');
      }
  
      onSubmitHandler2(evt) {
        evt.preventDefault();
        const self = this;
        
        const button = evt.currentTarget;
        const ids = button.getAttribute('data-ids').split(',').filter(Boolean);
const sellingPlans = button.getAttribute('data-selingplans').split(',').filter(Boolean);

  
        const buncledsProductAray = ids.map((id, index) => ({
          'id': id,
          'quantity': 1,
          'selling_plan': sellingPlans[index] || null,
          'properties': {
            '_bundleId': self.bundleId
          }
        }));
  
        if (buncledsProductAray.length > 0) {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
  
          const formData = new FormData();
  
          buncledsProductAray.forEach(item => {
            formData.append('items[][id]', item.id);
            formData.append('items[][quantity]', item.quantity);
            if (item.selling_plan) {
              formData.append('items[][selling_plan]', item.selling_plan);
            }
            formData.append('items[][properties][_bundleId]', self.bundleId);
          });
  
          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
  
          config.body = formData;
  
          fetch(`${routes.cart_add_url}`, config)
            .then(response => response.json())
            .then(response => {
              if (response.status) {
                this.handleErrorMessage(response.description);
  
                /*const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;*/
                this.submitButton.setAttribute('aria-disabled', true);
                this.error = true;
                return;
              } else if (!this.cart) {
                return;
              }
  
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener('modalClosed', () => {
                  setTimeout(() => { this.cart.renderContents(response) });
                }, { once: true });
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => { 
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            });
        }
      }
  
      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    });
  }